<template>
  <div class="browse_parts_list">
    <dl
      class="browse_parts_container"
      v-for="{ id, label } in parts_labels" :key="id">
        <dt
          class="parts_title"
          :class="{ opened: isSingle, hide: isPartsOnly }"
          @click="toggle"
        >
          <div class="title_container" :class="id">
            {{ label }}<ctg-arrow class="title__arrow black" />
          </div>
        </dt>
        <dd class="parts__content">
          <component
            :is="id === 'tape' ? 'list-tape-items' : 'select-parts-color'"
            :item_list="each_parts_list(id)"
          />
        </dd>
    </dl>
</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CtgArrow from "./parts/CtgArrow.vue";
import ListTapeItems from "./parts/ListTapeItems.vue";
import SelectPartsColor from "./SelectPartsColor.vue";



export default {
  name: "BrowsePartsList",
  components: { ListTapeItems, SelectPartsColor, CtgArrow },
  computed: {
    ...mapState('simulator', ['parts_list']),
    ...mapGetters('simulator', ['editing_productType']),
    parts_labels() {
      const uniqTypes = new Set(this.parts_list.map(
        ({ type }) => type !== 'tape' ? 'parts' : type
      ))
      const partsLabel = this.editing_productType === 'AB-50-TAPE' ? '木部材' : '部品色'
      return [...uniqTypes].map(
        type => ({
          id: type,
          label: type === 'tape' ? 'ラダーテープ' : partsLabel
        })
      )
    },
    isSingle() {
      return this.parts_labels.length === 1
    },
    isPartsOnly() {
      return this.isSingle && this.parts_labels.every(({ id }) => id === 'parts')
    },
    each_parts_list() {
      return (key) => {
        const judge = key === 'tape' ? (t) => t === 'tape' : (t) => t !== 'tape'
        return this.parts_list.filter(({ type }) => judge(type))
      }
    }
  },
  methods: {
    toggleOpenThenScrollTo(el) {
      const onOpenEnd = () => {
        el.removeEventListener("transitionend", onOpenEnd);
        el.scrollIntoView({ behavior: "smooth" });
      };
      el.addEventListener("transitionend", onOpenEnd);
      // el.classList.toggle("opened");
    },
    toggle(ev) {
      const { currentTarget } = ev;
      currentTarget.classList.toggle('opened')
      this.toggleOpenThenScrollTo(currentTarget);
    },
  },
};
</script>

<style lang="scss">
.browse_parts_list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
}
.browse_parts_container {
  display: grid;
  grid-template-rows: auto 0;
  margin: 0;
  max-height: 100%;
  font-size: clamp(10px, 1.5vw, 18px);
  .parts_title {
    position: relative;
    margin-bottom: calc(8 / 295 * 100%);
    border-radius: 50px;
    overflow: hidden;
    transition: margin 0.4s;
    border: 1px solid #040404;
    &::before {
      display: block;
      content: "";
      padding-top: calc(16 / 295 * 100%);
    }
    .title_container {
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      padding: 0 calc(16 / 295 * 100%);
      width: 100%;
      height: 100%;
      color: white;
      background-color: #ddd;
      &::before {
        display: block;
        margin-right: calc(10 / 295 * 100%);
        background: {
          size: cover;
          position: center;
          repeat: no-repeat;
        }
      }
      .title__arrow {
        position: absolute;
        right: calc(16 / 295 * 100%);
        display: block;
        width: calc(7 / 263 * 100%);
        height: calc(15 / 9 * 7 / 16 * 100%);
        transition: transform 0.2s;
      }
      &.tape, &.parts {
        color: #040404;
        background: white;
      }
    }
  }
  .parts__content {
    margin: 0;
    height: 0;
    overflow: hidden;
    transition: height 0.4s;
  }
  .parts_title.opened {
    margin-bottom: 0;
    .title_container {
      .title__arrow {
        transform: scale(1, -1);
      }
    }
    + .parts__content {
      height: auto;
      overflow-y: auto;
    }
  }
  .parts_title.opened.hide {
    display: none;
  }
  &:has(:is(.parts_title.opened)) {
    grid-template-rows: auto 1fr;
  }
}
</style>
